import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=05da8ee9&lang=pug&"
import script from "./confirm.ts?vue&type=script&lang=ts&"
export * from "./confirm.ts?vue&type=script&lang=ts&"
import style0 from "./confirm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports